import { CALL_API, Schemas } from '../../common/middleware/api';

export const WEEKLY_INFORMATIONS_REQUEST = 'WEEKLY_INFORMATIONS_REQUEST';
export const WEEKLY_INFORMATIONS_SUCCESS = 'WEEKLY_INFORMATIONS_SUCCESS';
export const WEEKLY_INFORMATIONS_FAILURE = 'WEEKLY_INFORMATIONS_FAILURE';

export const WEEKLY_INFORMATION_FETCH_REQUEST = 'WEEKLY_INFORMATION_GET_REQUEST';
export const WEEKLY_INFORMATION_FETCH_SUCCESS = 'WEEKLY_INFORMATION_GET_SUCCESS';
export const WEEKLY_INFORMATION_FETCH_FAILURE = 'WEEKLY_INFORMATION_GET_FAILURE';

export const WEEKLY_INFORMATION_CREATE_REQUEST = 'WEEKLY_INFORMATION_CREATE_REQUEST';
export const WEEKLY_INFORMATION_CREATE_SUCCESS = 'WEEKLY_INFORMATION_CREATE_SUCCESS';
export const WEEKLY_INFORMATION_CREATE_FAILURE = 'WEEKLY_INFORMATION_CREATE_FAILURE';

export const WEEKLY_INFORMATION_UPDATE_REQUEST = 'WEEKLY_INFORMATION_UPDATE_REQUEST';
export const WEEKLY_INFORMATION_UPDATE_SUCCESS = 'WEEKLY_INFORMATION_UPDATE_SUCCESS';
export const WEEKLY_INFORMATION_UPDATE_FAILURE = 'WEEKLY_INFORMATION_UPDATE_FAILURE';

export const loadWeeklyInformations = (options) => ({
	[CALL_API]: {
		types: [WEEKLY_INFORMATIONS_REQUEST, WEEKLY_INFORMATIONS_SUCCESS, WEEKLY_INFORMATIONS_FAILURE],
		endpoint: 'api/weeklyInformations',
		request: options,
		schema: Schemas.WEEKLY_INFORMATION_ARRAY
	}
});

export const fetchWeeklyInformation = (id) => ({
	[CALL_API]: {
		types: [WEEKLY_INFORMATION_FETCH_REQUEST, WEEKLY_INFORMATION_FETCH_SUCCESS, WEEKLY_INFORMATION_FETCH_FAILURE],
		endpoint: `api/weeklyInformations/${id}`,
		schema: Schemas.WEEKLY_INFORMATION
	}
});

export const createWeeklyInformation = (weeklyInformation, history) => ({
	[CALL_API]: {
		types: [WEEKLY_INFORMATION_CREATE_REQUEST, WEEKLY_INFORMATION_CREATE_SUCCESS, WEEKLY_INFORMATION_CREATE_FAILURE],
		endpoint: 'api/weeklyInformations',
		method: 'POST',
		request: weeklyInformation,
		schema: Schemas.WEEKLY_INFORMATION,
		form: 'weeklyInformation',
		transition: {
			history,
			successPath: (response) => {
				return `/weeklyInformations/${response.result}`;
			}
		}
	}
});

export const updateWeeklyInformation = (id, weeklyInformation) => ({
	[CALL_API]: {
		types: [WEEKLY_INFORMATION_UPDATE_REQUEST, WEEKLY_INFORMATION_UPDATE_SUCCESS, WEEKLY_INFORMATION_UPDATE_FAILURE],
		endpoint: `api/weeklyInformations/${id}`,
		method: 'PUT',
		request: weeklyInformation,
		schema: Schemas.WEEKLY_INFORMATION,
		form: 'weeklyInformation'
	}
});